import { useEffect, useRef, useState } from 'react';
import AdvisorService from 'scripts/services/AdvisorService';

export const usePortfolioHistory = (clientId) => {
  const [attempt, setAttempt] = useState(0);
  const [historyState, setHistoryState] = useState({
    clientId,
    loading: true,
    data: [],
    error: false,
  });

  useEffect(() => {
    let cancelled = false;
    setHistoryState({ clientId, loading: true, data: [], error: false });
    AdvisorService.getClientHistoricalAccountValues(clientId)
      .then((data) => {
        if (!Array.isArray(data)) throw new Error('Invalid portfolio history.');
        if (!cancelled) {
          setHistoryState({ clientId, loading: false, data, error: false });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setHistoryState({ clientId, loading: false, data: [], error: true });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [clientId, attempt]);

  return {
    loading: historyState.clientId !== clientId || historyState.loading,
    data: historyState.clientId === clientId ? historyState.data : [],
    error: historyState.error,
    retry: () => setAttempt((current) => current + 1),
  };
};

export const useActivityLayout = () => {
  const containerRef = useRef(null);
  const [summaryLayout, setSummaryLayout] = useState('stacked');
  const [filterLayout, setFilterLayout] = useState('stacked');

  useEffect(() => {
    const container = containerRef.current;
    const updateLayout = () => {
      const width = container.clientWidth;
      setSummaryLayout(width >= 650 ? 'inline' : 'stacked');
      setFilterLayout(
        width >= 800 ? 'wide' : width >= 480 ? 'split' : 'stacked',
      );
    };
    updateLayout();
    if (typeof window.ResizeObserver === 'function') {
      const observer = new window.ResizeObserver(updateLayout);
      observer.observe(container);
      return () => observer.disconnect();
    }
    window.addEventListener('resize', updateLayout);
    return () => window.removeEventListener('resize', updateLayout);
  }, []);

  return { containerRef, summaryLayout, filterLayout };
};
